module.exports = __webpack_public_path__ + "ducter_color.png?5a2a037b0a7ca84a5096d31a190e2d6d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ducter_color.png
// module id = 15
// module chunks = 0